module.exports = __webpack_public_path__ + "static/media/icon_nav_home.ea8d4285.svg";